/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Update cart count in header icon start
    const updateCartCount = (itemCount) => {
      const cartCountEl = document.getElementById('headerCartCount');
      if (cartCountEl && typeof itemCount === 'number') {
        if (itemCount > 0){
          document.querySelectorAll('.cart--icons').forEach(e => { e.classList.remove('cart--empty')})
          cartCountEl.textContent = itemCount;
        } else {
          document.querySelectorAll('.cart--icons').forEach(e => { e.classList.add('cart--empty')})
        }
        
      }
    };

    const originalFetch = window.fetch;

    window.fetch = (...args) => {
      const [url] = args;
      
      return originalFetch.apply(this, args).then(response => {
        const clonedResponse = response.clone();
        
        if (typeof url === 'string' && (
          url.includes('/cart/add.js') ||
          url.includes('/cart/update.js') ||
          url.includes('/cart/change.js') ||
          url.includes('/cart/clear.js')
        )) {
          clonedResponse.json().then(cart => {
            updateCartCount(cart.item_count);
          }).catch(() => {});
        }
        
        return response;
      });
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._url = url;
      
      this.addEventListener('load', function() {
        if (typeof this._url === 'string' && (
          this._url.includes('/cart/add.js') ||
          this._url.includes('/cart/update.js') ||
          this._url.includes('/cart/change.js') ||
          this._url.includes('/cart/clear.js')
        )) {
          try {
            const cart = JSON.parse(this.response);
            console.log('Cart updated via XHR:', cart);
            updateCartCount(cart.item_count);
          } catch (e) {}
        }
      });
      
      return originalOpen.apply(this, arguments);
    };

    document.addEventListener('theme:cart:change', (event) => {
      const [{ cart } = {}] = [event.detail || {}];
      const { item_count: itemCount } = cart || {};

      if (itemCount !== undefined) {
        updateCartCount(itemCount);
      }
    });
  // Update cart count in header icon end

  // AJAX Add to Cart start
    const initAjaxAddToCart = () => {    
      document.body.addEventListener('submit', async (e) => {
        if (!e.target.classList.contains('ajax-add-to-cart')) {
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        const form = e.target;
        const submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
        const variantId = form.querySelector('input[name="id"]').value;
        
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.dataset.originalValue = submitButton.value;
          submitButton.value = 'Adding...';
        }
        
        try {          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const item = await response.json();
          
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart }
          }));
          
          if (submitButton) {
            submitButton.value = 'Added!';
            setTimeout(() => {
              submitButton.value = submitButton.dataset.originalValue;
              submitButton.disabled = false;
            }, 2000);
          }
          
        } catch (error) {
          console.error('[AJAX Cart] Error adding to cart:', error);
          
          if (submitButton) {
            submitButton.value = 'Error - Try Again';
            setTimeout(() => {
              submitButton.value = submitButton.dataset.originalValue;
              submitButton.disabled = false;
            }, 2000);
          }
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAjaxAddToCart);
    } else {
      initAjaxAddToCart();
    }
  // AJAX Add to Cart end

  // // Kaktusc iframe customization
// const setupKaktusc = () => {
//   console.log('[Kaktusc] Starting setup...');
//   const iframe = document.getElementById('kaktusc-widget');
  
//   if (!iframe) {
//     console.log('[Kaktusc] Iframe not found, retrying in 500ms...');
//     setTimeout(setupKaktusc, 500);
//     return;
//   }
  
//   console.log('[Kaktusc] Iframe found');
//   let stylesInjected = false;
//   let observerSetup = false;
//   let focusTrapActive = false;
  
//   const injectStyles = () => {
//     if (stylesInjected) {
//       return;
//     }
    
//     try {
//       const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      
//       if (iframeDoc.getElementById('kaktusc-custom-styles')) {
//         stylesInjected = true;
//         return;
//       }
      
//       const style = iframeDoc.createElement('style');
//       style.id = 'kaktusc-custom-styles';
//       style.textContent = `
//         .kaktusc-cart__continue {
//           display: none !important;
//         }
        
//         /* Focus styles */
//         .kaktusc-cart__close:focus,
//         .kaktusc-cart__product-qnt--minus:focus,
//         .kaktusc-cart__product-qnt--plus:focus,
//         .kaktusc-cart__product-delete:focus,
//         .kaktusc-cart__checkout:focus {
//           outline: 3px solid #4A90E2 !important;
//           outline-offset: 2px !important;
//         }
        
//         /* Alternative focus style for better visibility */
//         .kaktusc-cart__close:focus {
//           box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.5) !important;
//         }
        
//         .kaktusc-cart__checkout:focus {
//           box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.5) !important;
//         }
//       `;
      
//       iframeDoc.head.appendChild(style);
//       stylesInjected = true;
//       console.log('[Kaktusc] ✓ Styles injected successfully');
//     } catch (e) {
//       console.error('[Kaktusc] Error injecting styles:', e);
//     }
//   };
  
//   const getFocusableElements = (iframeDoc) => {
//     const elements = [];
    
//     // Close button
//     const closeBtn = iframeDoc.querySelector('.kaktusc-cart__close');
//     if (closeBtn && closeBtn.offsetParent !== null) {
//       elements.push(closeBtn);
//     }
    
//     // Get all products
//     const products = iframeDoc.querySelectorAll('.kaktusc-cart__product');
//     products.forEach(product => {
//       // Minus button
//       const minus = product.querySelector('.kaktusc-cart__product-qnt--minus');
//       if (minus && minus.offsetParent !== null) {
//         elements.push(minus);
//       }
      
//       // Plus button
//       const plus = product.querySelector('.kaktusc-cart__product-qnt--plus');
//       if (plus && plus.offsetParent !== null) {
//         elements.push(plus);
//       }
      
//       // Delete button
//       const deleteBtn = product.querySelector('.kaktusc-cart__product-delete');
//       if (deleteBtn && deleteBtn.offsetParent !== null) {
//         elements.push(deleteBtn);
//       }
//     });
    
//     // Checkout button
//     const checkoutBtn = iframeDoc.querySelector('.kaktusc-cart__checkout');
//     if (checkoutBtn && checkoutBtn.offsetParent !== null) {
//       elements.push(checkoutBtn);
//     }
    
//     return elements;
//   };
  
//   const setupFocusTrap = (iframeDoc) => {
//     if (focusTrapActive) {
//       return;
//     }
    
//     console.log('[Kaktusc] Setting up focus trap...');
    
//     // Trap focus inside iframe with keydown handler
//     const iframeKeydownHandler = (e) => {
//       if (e.key !== 'Tab') return;
      
//       const focusableElements = getFocusableElements(iframeDoc);
      
//       if (focusableElements.length === 0) {
//         console.log('[Kaktusc] No focusable elements found');
//         e.preventDefault();
//         return;
//       }
      
//       const activeElement = iframeDoc.activeElement;
//       const currentIndex = focusableElements.indexOf(activeElement);
      
//       console.log('[Kaktusc] Tab pressed, current index:', currentIndex);
      
//       // Always prevent default to keep focus in iframe
//       e.preventDefault();
      
//       if (e.shiftKey) {
//         // Shift+Tab - go backwards
//         if (currentIndex <= 0) {
//           // Wrap to last element
//           focusableElements[focusableElements.length - 1].focus();
//           console.log('[Kaktusc] Shift+Tab wrapped to last element');
//         } else {
//           // Go to previous element
//           focusableElements[currentIndex - 1].focus();
//           console.log('[Kaktusc] Shift+Tab to previous element');
//         }
//       } else {
//         // Tab - go forwards
//         if (currentIndex === -1 || currentIndex >= focusableElements.length - 1) {
//           // Wrap to first element
//           focusableElements[0].focus();
//           console.log('[Kaktusc] Tab wrapped to first element');
//         } else {
//           // Go to next element
//           focusableElements[currentIndex + 1].focus();
//           console.log('[Kaktusc] Tab to next element');
//         }
//       }
//     };
    
//     // Also trap focus from parent document - only when focus is NOT in iframe
//     const parentKeydownHandler = (e) => {
//       if (e.key !== 'Tab') return;
      
//       const cartBody = iframeDoc.querySelector('.kaktusc-cart__body');
//       const isVisible = cartBody && cartBody.offsetParent !== null;
      
//       if (!isVisible) return;
      
//       // Check if active element is in the parent document (not iframe)
//       const activeElement = document.activeElement;
      
//       // If the active element is the iframe itself or not in iframe, redirect
//       if (activeElement === iframe || activeElement.tagName !== 'IFRAME') {
//         const focusableElements = getFocusableElements(iframeDoc);
//         if (focusableElements.length > 0) {
//           e.preventDefault();
//           focusableElements[0].focus();
//           console.log('[Kaktusc] Redirected focus from parent to iframe');
//         }
//       }
//     };
    
//     iframeDoc.addEventListener('keydown', iframeKeydownHandler);
//     document.addEventListener('keydown', parentKeydownHandler);
//     focusTrapActive = true;
//     console.log('[Kaktusc] ✓ Focus trap activated');
    
//     return () => {
//       iframeDoc.removeEventListener('keydown', iframeKeydownHandler);
//       document.removeEventListener('keydown', parentKeydownHandler);
//       focusTrapActive = false;
//       console.log('[Kaktusc] Focus trap deactivated');
//     };
//   };
  
//   const manageFocus = () => {
//     console.log('[Kaktusc] Setting up focus management...');
//     try {
//       const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
//       const cartRoot = iframeDoc.getElementById('kaktusc-root');
      
//       if (!cartRoot) {
//         console.log('[Kaktusc] Cart root not found in manageFocus');
//         return;
//       }
      
//       console.log('[Kaktusc] Cart root found, setting up MutationObserver');
      
//       let cleanupFocusTrap = null;
//       let lastVisibleState = false;
//       let productsLoaded = false;
      
//       // Watch for cart becoming visible
//       const observer = new MutationObserver((mutations) => {
//         // Inject styles whenever content changes
//         injectStyles();
        
//         const cartBody = iframeDoc.querySelector('.kaktusc-cart__body');
//         const products = iframeDoc.querySelectorAll('.kaktusc-cart__product');
        
//         // Check if cart is visible
//         const isVisible = cartBody && cartBody.offsetParent !== null;
        
//         // Check if products have loaded
//         if (isVisible && products.length > 0 && !productsLoaded) {
//           productsLoaded = true;
//           console.log(`[Kaktusc] Products loaded: ${products.length} items`);
          
//           // Wait a bit more for all elements to be fully rendered, then focus
//           setTimeout(() => {
//             const focusableElements = getFocusableElements(iframeDoc);
//             console.log(`[Kaktusc] Total focusable elements: ${focusableElements.length}`);
            
//             if (focusableElements.length > 0) {
//               focusableElements[0].focus();
//               console.log('[Kaktusc] ✓ Focus set to first element (close button)');
//             }
//           }, 200);
//         }
        
//         // Only act if visibility state changed
//         if (isVisible !== lastVisibleState) {
//           lastVisibleState = isVisible;
          
//           if (isVisible) {
//             console.log('[Kaktusc] Cart opened');
//             productsLoaded = false;
            
//             // Set up focus trap
//             if (!focusTrapActive) {
//               cleanupFocusTrap = setupFocusTrap(iframeDoc);
//             }
            
//             // Make iframe not tabbable from outside
//             iframe.setAttribute('tabindex', '-1');
//           } else {
//             console.log('[Kaktusc] Cart closed');
//             productsLoaded = false;
            
//             // Clean up focus trap when cart closes
//             if (cleanupFocusTrap && focusTrapActive) {
//               cleanupFocusTrap();
//               cleanupFocusTrap = null;
//             }
//           }
//         }
//       });
      
//       observer.observe(cartRoot, {
//         attributes: true,
//         childList: true,
//         subtree: true
//       });
      
//       observerSetup = true;
//       console.log('[Kaktusc] ✓ Observer setup complete');
//     } catch (e) {
//       console.error('[Kaktusc] Error setting up focus management:', e);
//     }
//   };
  
//   const initialize = () => {
//     console.log('[Kaktusc] Initialize called');
//     try {
//       const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
//       const cartRoot = iframeDoc.getElementById('kaktusc-root');
      
//       if (cartRoot) {
//         console.log('[Kaktusc] Cart root exists');
//         // Cart root exists, set up observer
//         if (!observerSetup) {
//           manageFocus();
//         }
        
//         // Try to inject styles immediately if content already loaded
//         const cartWrap = iframeDoc.querySelector('.kaktusc-cart__wrap');
//         if (cartWrap) {
//           console.log('[Kaktusc] Cart wrap found, injecting styles immediately');
//           injectStyles();
//         } else {
//           console.log('[Kaktusc] Cart wrap not found yet, waiting for mutations');
//         }
//       } else {
//         console.log('[Kaktusc] Cart root not found, retrying in 500ms...');
//         // Cart root doesn't exist yet, wait a bit and try again
//         setTimeout(initialize, 500);
//       }
//     } catch (e) {
//       console.error('[Kaktusc] Error initializing:', e);
//     }
//   };
  
//   if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
//     console.log('[Kaktusc] Iframe already loaded, initializing...');
//     initialize();
//   } else {
//     console.log('[Kaktusc] Waiting for iframe load event...');
//     iframe.addEventListener('load', () => {
//       console.log('[Kaktusc] Iframe load event fired');
//       initialize();
//     });
//   }
// };

// // Initialize Kaktusc when DOM is ready
// if (document.readyState === 'loading') {
//   console.log('[Kaktusc] DOM loading, waiting for DOMContentLoaded...');
//   document.addEventListener('DOMContentLoaded', setupKaktusc);
// } else {
//   console.log('[Kaktusc] DOM already loaded, running setup...');
//   setupKaktusc();
// }
// // Kaktusc end

  // Homepage image-with-text video modal start
    const indexRowVideoModal = (() => {
      let activeTrigger = null;

      const getVideoSrc = (trigger) => {
        const videoType = trigger.getAttribute('data-video-type');
        const videoId = encodeURIComponent(trigger.getAttribute('data-video-id'));

        if (videoType === 'vimeo') {
          return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }

        return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
      };

      const getModal = (trigger) => {
        const modalId = trigger.getAttribute('data-modal-id');
        return modalId ? document.getElementById(modalId) : null;
      };

      const open = (trigger, event) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        const modal = getModal(trigger);
        const frameTarget = modal ? modal.querySelector('[data-index-row-video-frame]') : null;

        if (!modal || !frameTarget) {
          return;
        }

        const modalContainer = document.querySelector('[data-modal-container]') || document.body;
        activeTrigger = trigger;

        if (modal.parentNode !== modalContainer) {
          modalContainer.appendChild(modal);
        }

        frameTarget.innerHTML = `
          <iframe
            src="${getVideoSrc(trigger)}"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
            title="Video player"
          ></iframe>
        `;

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        const closeButton = modal.querySelector('[data-index-row-video-close]');
        if (closeButton) {
          closeButton.focus();
        }
      };

      const close = (modal, event) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        const targetModal = modal || document.querySelector('[data-index-row-video-modal].is-open');

        if (!targetModal) {
          return;
        }

        const frameTarget = targetModal.querySelector('[data-index-row-video-frame]');

        targetModal.classList.remove('is-open');
        targetModal.setAttribute('aria-hidden', 'true');

        if (frameTarget) {
          frameTarget.innerHTML = '';
        }

        document.body.style.overflow = '';

        if (activeTrigger && typeof activeTrigger.focus === 'function') {
          activeTrigger.focus();
        }
      };

      return {
        open,
        close
      };
    })();

    window.indexRowVideoModal = indexRowVideoModal;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-index-row-video-open]');

      if (trigger) {
        indexRowVideoModal.open(trigger, event);
        return;
      }

      const closeTrigger = event.target.closest('[data-index-row-video-close]');

      if (closeTrigger) {
        indexRowVideoModal.close(closeTrigger.closest('[data-index-row-video-modal]'), event);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        indexRowVideoModal.close();
      }
    });
  // Homepage image-with-text video modal end

    
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
